import { ClientErrorCodes } from '@logicalcommander/types'
import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useAppDispatch } from '../../../redux/hooks'
import { setClientErrorCode } from '../../../redux/reducers/generalSlice'
import { LCToast } from '../lc-toast/Toast'

interface Props {
  code: ClientErrorCodes | undefined
}

export const LCClientErrorCodeNotification: FC<Props> = ({ code }: Props) => {
  const { t } = useTranslation('e-commander-common', { keyPrefix: 'client-errors' })
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (code) {
      try {
        const title = t(`${code}.title`)
        const body = t(`${code}.body`)
        toast.error(<LCToast title={title} body={body} />)
      } catch (error) {
        console.error('Error showing toast:', error)
      }
      setTimeout(() => {
        dispatch(setClientErrorCode(undefined))
      }, 100)
    }
  }, [code, dispatch, t])

  return null
}
